// Registration/signup policy: letter + digit + special character (any case).
export function isRegistrationPasswordValid(password) {
  const value = String(password || '');
  return (
    value.length >= 8
    && /[A-Za-z\u0600-\u06FF]/.test(value)
    && /\d/.test(value)
    && /[^A-Za-z0-9\u0600-\u06FF]/.test(value)
  );
}

export function registrationPasswordError(password) {
  const value = String(password || '');
  if (!value) return 'رمز عبور الزامی است';
  if (value.length < 8) return 'رمز عبور باید حداقل ۸ کاراکتر باشد';
  if (!/[A-Za-z\u0600-\u06FF]/.test(value)) return 'رمز عبور باید شامل حرف باشد';
  if (!/\d/.test(value)) return 'رمز عبور باید شامل عدد باشد';
  if (!/[^A-Za-z0-9\u0600-\u06FF]/.test(value)) return 'رمز عبور باید شامل کاراکتر خاص باشد (!@#$...)';
  return '';
}

// Simple, dependency-free password strength scorer - counts how many of
// five common criteria are met (length, lowercase, uppercase, digit,
// special char) and maps the count to a 0-4 score with a Persian label/color.
// Not a substitute for a real entropy-based scorer (e.g. zxcvbn) but good
// enough for a live "how strong is this" hint without adding a dependency.
export function getPasswordStrength(password) {
  const value = password || '';
  const criteria = [
    value.length >= 8,
    value.length >= 12,
    /[a-z]/.test(value) && /[A-Z]/.test(value),
    /\d/.test(value),
    /[^A-Za-z0-9]/.test(value),
  ];
  const score = value ? criteria.filter(Boolean).length : 0;

  const levels = [
    { label: 'خیلی ضعیف', color: '#ef4444' },
    { label: 'ضعیف', color: '#f59e0b' },
    { label: 'متوسط', color: '#eab308' },
    { label: 'خوب', color: '#22c55e' },
    { label: 'قوی', color: '#16a34a' },
  ];
  const level = levels[Math.min(score, levels.length - 1)];

  return { score, max: criteria.length, label: level.label, color: level.color };
}
